export const ACCESS_TOKEN_EXPIRATION_IN_MINUTES = 10;